
<i class="material-icons close-dialog" (click)="closeDialog()">close</i>
<img [src]="data?.imageUrl" alt="" class="w-100 image-wrap" width="1920px" height="1080" [alt]="data?.alt" [title]="data?.alt">
<!-- <div class="toll-free-header d-flex align-items-start justify-content-between">
    <div>
        <h4><span>📢</span> Exciting Update!</h4>
        <p>Switch to <strong class="toll-free-header--bolder">10505</strong> for <strong>UMANG Support!</strong></p>
    </div>
    <i class="material-icons" (click)="closeDialog()">close</i>
</div>
<div class="toll-free-mid">
    <p>Your go-to helpline number has changed!</p>
    <p>Save 10505 now for quick assistance with all your queries.</p>
</div>

<div class="toll-free-why mb-0">
    <h5>Why Save It?</h5>
    <ul>
        <li><span>📞</span>Easy Access to Support</li>
        <li><span>⚡</span>Instant Resolution</li>
    </ul>
</div>

<div class="toll-free-footer" *ngIf="false">
    <p>Tap "<strong>Call Now</strong>" to never miss out on assistance when you need it most.</p>
</div>
<div class="button-wrapper justify-content-center" *ngIf="false">
    <a class="btn btn-primary" href="tel:10505">Call Now</a>
</div> -->